import styled from 'styled-components';

export const Container = styled.div`
  padding: 15px 0 30px 0;
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

export const PageTitle = styled.h1`
  font-weight: 700;
  font-size: 24px;
  color: #263238;

  margin-top: 10px;

  &.main__title {
    margin-bottom: 15px;
  }
`;

export const Subtitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  color: #263238;
  margin-top: 5px;
`;

export const SemBannerTitle = styled.div`
  p {
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
    margin-left: 12px;
  }
`;

export const InfoBanner = styled.div`
  p,
  li {
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
  }
  p {
    margin-bottom: 8px;
  }
  li {
    list-style-type: disclosure-closed;
  }
  ul.observation {
    margin-left: 20px;
  }
`;

export const ContentBanner = styled.div`
  width: 100%;
  margin: 30px;
  background: #fff;
  border-radius: 4px;
  overflow-x: auto;

  border: 2px solid rgb(230, 239, 251);
  padding: 10px;
  margin: 15px 0px;
`;

export const ButtonSaveBanner = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;

  button {
    padding: 5px 8px;
    border-radius: 5px;
    border: 1px solid transparent;
    background-color: #329bfc;
    color: #fff;

    :hover {
      opacity: 0.8;
    }
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    width: 600px;
    height: 600px;
    border-radius: 8px;
  }

  h1 {
    font-weight: 700;
    font-size: 24px;
    color: #263238;
    padding-top: 10px;
    text-align: center;
  }

  .closeModal {
    position: absolute;
    top: 12px;
    right: 12px;
    border: none;
    font-size: 20px;
    color: #555;
    background: transparent;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    transition: 0.3s;

    :hover {
      background: red;
      color: white;
    }
  }
`;

export const LineDividerStyled = styled.div`
  border-bottom: 2px solid #ddd;
`;

export const ModalContainerConteudo = styled.section<{ withButton?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  max-height: calc(100% - 45px);

  p {
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
    margin-bottom: 5px;
  }
`;

export const ButtonNext = styled.button`
  width: 80px;
  height: 30px;
  border: 1px solid transparent;
  border-radius: 5px;
  background-color: #3f51b5;
  color: #fff;
`;

export const ModalFooter = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 10px;
  border-top: 2px solid #ddd;
`;
